import { Component, Input } from '@angular/core';
import { ModelEventDto } from '@careapp-group/ng-sdk-v2-new';
import { MemberDto } from '@careapp-group/ng-sdk-v2-new';

@Component({
  selector: 'ca-entity-history-item',
  styleUrls: ['./entity-history-item.component.scss'],
  templateUrl: './entity-history-item.component.html',
})
export class EntityHistoryItemComponent {
  @Input() event: ModelEventDto;
  @Input() member: MemberDto;
  // Text to be displayed underneath this action.
  @Input() trailing: String;
}
